import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import ErrorBlock from '../ErrorBlock';

export function FormErrorBlock({ errors, type }) {
  const error = get(errors, type);

  if (error) {
    return <ErrorBlock errors={error} className="mt3" />;
  }

  return null;
}

FormErrorBlock.propTypes = {
  type: PropTypes.string,
  errors: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};



// WEBPACK FOOTER //
// ./src/components/common/FormErrorBlock/index.jsx